const config = {
    build_number: '615394',
    build_timestamp: '2026-08-17T17:12:44.371Z',
    build_commit: '32aeb39e6a3da86fb343a437e8ea642cb6648b65',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
